"use strict";

var _interopRequireDefault = require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
var _customField = require("@/api/customField");
var _tags = require("@/api/creation/tags");
var _name$model$props$dat; //
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = (_name$model$props$dat = {
  name: "TagCustomField",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    type: {
      type: String,
      default: 1 // 1标签 2关键词
    }
  },
  data: function data() {
    return {
      loading: false,
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      restaurants: []
    };
  },
  watch: {
    Tags: function Tags(newVal, oldVal) {
      if (newVal.length > 0) {
        this.dynamicTags = newVal.split(',');
      } else {
        this.dynamicTags = [];
      }
    }
  }
}, (0, _defineProperty2.default)(_name$model$props$dat, "props", {
  value: {
    type: String
  },
  Tags: {
    type: String,
    default: ''
  },
  customTitle: {
    type: String,
    default: ''
  },
  customProp: {
    type: String,
    default: 'type'
  }
}), (0, _defineProperty2.default)(_name$model$props$dat, "methods", {
  querySearch: function () {
    var _querySearch = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(queryString, cb) {
      var res, list;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            res = {};
            if (!(this.type == 1)) {
              _context.next = 7;
              break;
            }
            _context.next = 4;
            return (0, _tags.getTagList)({
              tag_name: queryString
            });
          case 4:
            res = _context.sent;
            _context.next = 10;
            break;
          case 7:
            _context.next = 9;
            return (0, _tags.getKeywordList)({
              key_name: queryString
            });
          case 9:
            res = _context.sent;
          case 10:
            // 调用 callback 返回建议列表的数据
            if (res.data && res.data.list && res.data.list.length > 0) {
              list = res.data.list;
              if (this.type == 1) {
                list.forEach(function (x) {
                  x.value = x.tag_name;
                });
              } else {
                list.forEach(function (x) {
                  x.value = x.key_name;
                });
              }
              cb(list);
            } else {
              cb([{
                value: queryString
              }]);
            }
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function querySearch(_x, _x2) {
      return _querySearch.apply(this, arguments);
    }
    return querySearch;
  }(),
  handleSelect: function handleSelect(item) {
    console.log(item);
  },
  sendResult: function sendResult() {
    this.$emit('change', this.dynamicTags.join(','));
  },
  handleClose: function handleClose(tag) {
    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    this.sendResult();
  },
  showInput: function showInput() {
    var _this = this;
    this.inputVisible = true;
    this.$nextTick(function (_) {
      _this.$refs.saveTagInput.$refs.input.focus();
    });
  },
  handleInputConfirm: function handleInputConfirm() {
    var inputValue = this.inputValue;
    if (this.dynamicTags.indexOf(inputValue) > -1) {
      this.$message.error('标签已存在');
      return;
    }
    if (inputValue) {
      this.dynamicTags.push(inputValue);
    }
    this.inputVisible = false;
    this.inputValue = '';
    this.sendResult();
  }
}), (0, _defineProperty2.default)(_name$model$props$dat, "mounted", function mounted() {
  if (this.Tags.length > 0) {
    this.dynamicTags = this.Tags.split(',');
  } else {
    this.dynamicTags = [];
  }
}), _name$model$props$dat);
exports.default = _default;